import * as React from 'react';
import { FilterButton } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';

// This number is the restricted number of responses when appling filters.
// Only a few Opco's have a response with more than 30 stores. Because this number
// initially isn't available it's set here.
const COUNT_LIMIT = 30;
const StoreFilters = ({ filters , appliedFilters , toggleFilter , isLoadingResults  })=>{
    const { getLabel  } = useIntl();
    const { featureConfigs  } = useFeatureToggles();
    const maxSearchStoresResults = (featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.maxSearchStoresResults) !== undefined ? featureConfigs.maxSearchStoresResults : COUNT_LIMIT;
    return /*#__PURE__*/ React.createElement("div", {
        className: "store-filters__container"
    }, filters.map(({ name: filterKey , options  })=>{
         return React.createElement("div", {
            key: filterKey,
            className: "store-filters__section"
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "subheading1",
            className: "store-filters__section-title"
        }, getLabel(`stores.storeFilters.filters.${filterKey}`)), /*#__PURE__*/ React.createElement("div", {
            className: "store-filters__filters"
        }, options.map(({ name: optionKey , count  })=>{
            var ref;
            const isFilterSelected = !!((ref = appliedFilters[filterKey]) === null || ref === void 0 ? void 0 : ref.find((option)=>option === optionKey
            ));
            const optionName = getLabel(`stores.storeFilters.filters.${filterKey}.${optionKey}`);
            const filterLabelCount = isLoadingResults ? '' : count && count < maxSearchStoresResults || count === 0 ? `(${count})` : `(${maxSearchStoresResults})`;
            const filterLabel = isFilterSelected ? optionName : `${optionName} ${filterLabelCount}`;
            return /*#__PURE__*/ React.createElement(FilterButton, {
                key: optionName,
                caption: filterLabel,
                icon: isFilterSelected ? 'clear' : undefined,
                isSelected: isFilterSelected,
                onClick: ()=>toggleFilter(filterKey, optionKey)
            });
        })));
    }));
};

export { StoreFilters as default };
//# sourceMappingURL=StoreFilters.js.map
